const REQUEST_PERIOD = 'requestPeriod';
const SEVEN_DAYS_WEEK = 'sevenDaysWeek';

export const DailyRuleType = Object.freeze({
    [REQUEST_PERIOD]: 0,
    [SEVEN_DAYS_WEEK]: 1,
});

export const DailyRuleTypeNames = Object.freeze({
    0: REQUEST_PERIOD,
    1: SEVEN_DAYS_WEEK,
});